import { render, staticRenderFns } from "./PrintShopMail.vue?vue&type=template&id=3938f1fa&scoped=true&"
import script from "./PrintShopMail.vue?vue&type=script&lang=js&"
export * from "./PrintShopMail.vue?vue&type=script&lang=js&"
import style0 from "./PrintShopMail.vue?vue&type=style&index=0&id=3938f1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938f1fa",
  null
  
)

export default component.exports